import React from 'react';
import PropTypes from 'prop-types';
import { Alignment } from '../Alignment/Alignment';
import styles from './DataPairLayout.scss';

export const DataPairLayout = props => {
  return (
    <div>
      <Alignment xs="left" md="left">
        {props.title}
      </Alignment>
      <div className={styles['children-container']}>
        <Alignment xs="left" md="left">
          {props.children}
        </Alignment>
      </div>
    </div>
  );
};

DataPairLayout.propTypes = {
  /** Title to be shown on the top */
  title: PropTypes.node.isRequired,
  /** Text to be shown on the content */
  children: PropTypes.node.isRequired
};
